// Dock storage capacity: total (unit: KB), used (unit: KB)
export interface AirportStorage {
  total: number, // Unit: KB
  used: number
}

// Dock cover state
export enum CoverStateEnum {
  Close = 0, // Closed
  Open = 1, // Open
  HalfOpen = 2, // Half open
  Failed = 3 // Failed
}

// Putter state
export enum PutterStateEnum {
  Close = 0, // Retracted
  Open = 1, // Extended
  HalfOpen = 2, // Half extended
  Failed = 3 // Failed
}

// Charging state
export enum ChargeStateEnum {
  NotCharge = 0, // Idle
  Charge = 1, // Charging
}

export interface DroneChargeState {
  state: ChargeStateEnum,
  capacity_percent: string,
}

// Fill light state
export enum SupplementLightStateEnum {
  Close = 0, // Off
  Open = 1, // On
}

// Dock sound & light alarm state
export enum AlarmModeEnum {
  CLOSE = 0, // Off
  OPEN = 1, // On
}

// Battery maintenance (storage mode)
export enum BatteryStoreModeEnum {
  BATTERY_PLAN_STORE = 1, // Planned battery storage strategy
  BATTERY_EMERGENCY_STORE = 2, // Emergency battery storage strategy
}

// Aircraft battery maintenance
export enum DroneBatteryStateEnum {
  NoMaintenanceRequired = 0, // 0-no maintenance needed
  MaintenanceRequired = 1, // 1-maintenance needed
  MaintenanceInProgress = 2, // 2-maintenance in progress
}

export enum DroneBatteryModeEnum {
  CLOSE = 0, // Off
  OPEN = 1, // On
}

// 4G link connection state
export enum FourGLinkStateEnum {
  CLOSE = 0, // Disconnected
  OPEN = 1, // Connected
}

//  SDR link connection state
export enum SdrLinkStateEnum {
  CLOSE = 0, // Disconnected
  OPEN = 1, // Connected
}

// Dock video transmission link mode
export enum LinkWorkModeEnum {
  SDR = 0, // SDR mode
  FourG_FUSION_MODE = 1, // 4G fusion mode
}
